module.exports = __webpack_public_path__ + "img/account-settings.7e8f5c3d.svg";